import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["text-white text-xs w-6 h-6 rounded flex items-center justify-center shadow-md", `${_ctx.bgColor}`])
  }, _toDisplayString(_ctx.abbr), 3))
}